import React from 'react';
import { IonToast } from '@ionic/react';
import { useSelector, useDispatch } from 'react-redux';
import AppActions, { AppSelectors } from 'redux/AppRedux';

function Toast() {
  const toast = useSelector(AppSelectors.selectToast);
  const dispatch = useDispatch();

  if (!toast) {
    return null;
  }

  return (
    <IonToast
      isOpen={!!toast}
      key={toast.message}
      message={toast.message}
      duration={3000}
      color={toast.color}
      onDidDismiss={() => dispatch(AppActions.setToast(null))}
      buttons={[
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
            dispatch(AppActions.setToast(null));
          },
        },
      ]}
    />
  );
}

export default Toast;
